<template>
<div class="chapter">
<div class="inner_page">
<h6 class="halftitle1"><a id="page_x"></a><a id="page_xi"></a>SUPER BLACK</h6>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292735453_07_hlf1.vue?182ee240